import { integrationScheduleResponseSchema } from '@tempo-io/work-integration-dto';
import { HTTPError } from 'ky';
import { z } from 'zod';
import { tempoApi } from '@/common/api/tempoApi';

export const ScheduleCadence = {
  EVERY_30_MINUTES: '30m',
  EVERY_60_MINUTES: '60m',
} as const;

export type ScheduleCadence = (typeof ScheduleCadence)[keyof typeof ScheduleCadence];

export interface IntegrationScheduleResponse {
  pull: boolean;
  push: boolean;
  cadence: ScheduleCadence;
}

export const integrationSchedulePutRequestSchema = z.object({
  pull: z.boolean(),
  push: z.boolean(),
  cadence: z.enum([ScheduleCadence.EVERY_30_MINUTES, ScheduleCadence.EVERY_60_MINUTES]),
});

export type IntegrationSchedulePutRequest = z.infer<typeof integrationSchedulePutRequestSchema>;

const getIntegrationSchedule = async (
  integrationId: number,
): Promise<IntegrationScheduleResponse | null> => {
  try {
    const response = await tempoApi()
      .get(`api/v1/work-integrations/${integrationId}/schedule`)
      .json();
    return integrationScheduleResponseSchema.parse(response);
  } catch (error) {
    if (error instanceof HTTPError && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};

const upsertIntegrationSchedule = async (
  integrationId: number,
  payload: IntegrationSchedulePutRequest,
): Promise<IntegrationScheduleResponse> => {
  const response = await tempoApi()
    .put(`api/v1/work-integrations/${integrationId}/schedule`, { json: payload })
    .json();
  return integrationScheduleResponseSchema.parse(response);
};

const deleteIntegrationSchedule = async (integrationId: number): Promise<void> => {
  await tempoApi().delete(`api/v1/work-integrations/${integrationId}/schedule`);
};

export const IntegrationScheduleApi = {
  getIntegrationSchedule,
  upsertIntegrationSchedule,
  deleteIntegrationSchedule,
};
